import { render, staticRenderFns } from "./ShopProduct.vue?vue&type=template&id=65a6eec2&scoped=true&"
import script from "./ShopProduct.vue?vue&type=script&lang=ts&"
export * from "./ShopProduct.vue?vue&type=script&lang=ts&"
import style0 from "./ShopProduct.vue?vue&type=style&index=0&id=65a6eec2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a6eec2",
  null
  
)

export default component.exports